import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37b8c4c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user-infos-edition" }
const _hoisted_2 = { class: "profile-form form-box" }
const _hoisted_3 = {
  key: 1,
  class: "info-box success-message"
}
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = {
  class: "form-items",
  for: "email"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  class: "form-items",
  for: "password-field"
}
const _hoisted_8 = {
  class: "form-items",
  for: "new-password-field"
}
const _hoisted_9 = { class: "form-buttons" }
const _hoisted_10 = {
  class: "confirm",
  type: "submit"
}

import {
    ComputedRef,
    Ref,
    computed,
    reactive,
    ref,
    toRefs,
    onMounted,
    watch,
    onUnmounted,
  } from 'vue'

  import PasswordInput from '@/components/Common/PasswordInput.vue'
  import { AUTH_USER_STORE, ROOT_STORE } from '@/store/constants'
  import { TAppConfig } from '@/types/application'
  import { IUserProfile, IUserAccountPayload } from '@/types/user'
  import { useStore } from '@/use/useStore'

  interface Props {
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
  }

  
  const { user } = toRefs(props)

  const store = useStore()
  const userForm: IUserAccountPayload = reactive({
    email: '',
    password: '',
    new_password: '',
  })
  const loading = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.USER_LOADING]
  )
  const appConfig: ComputedRef<TAppConfig> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_CONFIG]
  )
  const isSuccess: ComputedRef<boolean> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.IS_SUCCESS]
  )
  const emailUpdate = ref(false)
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )
  const formErrors = ref(false)
  const displayModal: Ref<boolean> = ref(false)

  onMounted(() => {
    if (props.user) {
      updateUserForm(props.user)
    }
  })

  function invalidateForm() {
    formErrors.value = true
  }
  function updateUserForm(user: IUserProfile) {
    userForm.email = user.email
  }
  function updatePassword(password: string) {
    userForm.password = password
  }
  function updateNewPassword(new_password: string) {
    userForm.new_password = new_password
  }
  function updateProfile() {
    const payload: IUserAccountPayload = {
      email: userForm.email,
      password: userForm.password,
    }
    if (userForm.new_password) {
      payload.new_password = userForm.new_password
    }
    emailUpdate.value = userForm.email !== user.value.email
    store.dispatch(AUTH_USER_STORE.ACTIONS.UPDATE_USER_ACCOUNT, payload)
  }
  function updateDisplayModal(value: boolean) {
    displayModal.value = value
  }
  function deleteAccount(username: string) {
    store.dispatch(AUTH_USER_STORE.ACTIONS.DELETE_ACCOUNT, { username })
  }

  onUnmounted(() => {
    store.commit(AUTH_USER_STORE.MUTATIONS.UPDATE_IS_SUCCESS, false)
    store.commit(ROOT_STORE.MUTATIONS.EMPTY_ERROR_MESSAGES)
  })

  watch(
    () => isSuccess.value,
    async (isSuccessValue) => {
      if (isSuccessValue) {
        updatePassword('')
        updateNewPassword('')
        updateUserForm(user.value)
        formErrors.value = false
      }
    }
  )
  watch(
    () => user.value.email,
    async () => {
      updateUserForm(user.value)
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (displayModal.value)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: _ctx.$t('common.CONFIRMATION'),
          message: _ctx.$t('user.CONFIRM_ACCOUNT_DELETION'),
          onConfirmAction: _cache[0] || (_cache[0] = ($event: any) => (deleteAccount(_unref(user).username))),
          onCancelAction: _cache[1] || (_cache[1] = ($event: any) => (updateDisplayModal(false)))
        }, null, 8, ["title", "message"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_unref(errorMessages))
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            message: _unref(errorMessages)
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      (_unref(isSuccess))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(
            `user.PROFILE.SUCCESSFUL_${
              emailUpdate.value && _unref(appConfig).is_email_sending_enabled ? 'EMAIL_' : ''
            }UPDATE`
          )), 1))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        class: _normalizeClass({ errors: formErrors.value }),
        onSubmit: _withModifiers(updateProfile, ["prevent"])
      }, [
        _createElementVNode("label", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.EMAIL')) + "* ", 1),
          _withDirectives(_createElementVNode("input", {
            id: "email",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userForm).email) = $event)),
            disabled: _unref(loading),
            required: true,
            onInvalid: invalidateForm
          }, null, 40, _hoisted_6), [
            [_vModelText, _unref(userForm).email]
          ])
        ]),
        _createElementVNode("label", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.CURRENT_PASSWORD')) + "* ", 1),
          _createVNode(PasswordInput, {
            id: "password-field",
            disabled: _unref(loading),
            password: _unref(userForm).password,
            required: true,
            onUpdatePassword: updatePassword,
            onPasswordError: invalidateForm
          }, null, 8, ["disabled", "password"])
        ]),
        _createElementVNode("label", _hoisted_8, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.NEW_PASSWORD')) + " ", 1),
          _createVNode(PasswordInput, {
            id: "new-password-field",
            disabled: _unref(loading),
            checkStrength: true,
            password: _unref(userForm).new_password,
            isSuccess: false,
            onUpdatePassword: updateNewPassword,
            onPasswordError: invalidateForm
          }, null, 8, ["disabled", "password"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.$t('buttons.SUBMIT')), 1),
          _createElementVNode("button", {
            class: "cancel",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$router.push('/profile')), ["prevent"]))
          }, _toDisplayString(_ctx.$t('buttons.CANCEL')), 1),
          _createElementVNode("button", {
            class: "danger",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (updateDisplayModal(true)), ["prevent"]))
          }, _toDisplayString(_ctx.$t('buttons.DELETE_MY_ACCOUNT')), 1)
        ])
      ], 42, _hoisted_4)
    ])
  ]))
}
}

})